import React, { Fragment, useEffect } from "react";
import { useDispatch } from "react-redux";
import * as actionCreators from "./actions.js";

const EventLookupService = () => {
	const dispatch = useDispatch();
	const { getEventLookups } = actionCreators;

	useEffect(() => {
		dispatch(getEventLookups());
	}, []);

	return <Fragment />;
};

export default EventLookupService;
